import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import LightingTheWayForEveryFamily from "./sections/LightingTheWayForEveryFamily";
import OurHeartAndMission from "./sections/OurHeartAndMission";
import HowWeSupportYou from "./sections/HowWeSupportYou";
import JoinOurNextCelebration from "./sections/JoinOurNextCelebration";
import VoicesOfOurCommunity from "./sections/VoicesOfOurCommunity";
import StartYourJourneyWithUs from "./sections/StartYourJourneyWithUs";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <LightingTheWayForEveryFamily />
      <OurHeartAndMission />
      <HowWeSupportYou />
      <JoinOurNextCelebration />
      <VoicesOfOurCommunity />
      <StartYourJourneyWithUs />
      <Footer />
    </div>;
}